var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "playVideo" }, [
    this.$store.state.webNavigator == "pc"
      ? _c("div", [
          _c("div", { staticClass: "modal" }, [
            _c("div", { staticClass: "modal-dialog" }, [
              _c("div", {
                staticClass: "icon-pc-3 locate",
                on: {
                  click: function($event) {
                    return _vm.close()
                  }
                }
              }),
              _c("div", [
                _c("div", { staticClass: "video-name" }, [
                  _c("p", [_vm._v(_vm._s(_vm.videoTlt))]),
                  _c("video", {
                    staticClass: "playVideo-player",
                    attrs: {
                      id: "vidPc",
                      src: _vm.videoPlay,
                      controls: "controls",
                      width: "975px",
                      autostart: "false",
                      loop: "false"
                    }
                  })
                ])
              ])
            ])
          ])
        ])
      : _vm._e(),
    this.$store.state.webNavigator == "phone"
      ? _c("div", [
          _c("div", { staticClass: "modal" }, [
            _c("div", { staticClass: "phoneVideo-Dialog" }, [
              _c("div", {}, [
                _c(
                  "p",
                  { staticClass: "displayIB phoneVideo-name font24phone" },
                  [_vm._v(_vm._s(_vm.videoTlt))]
                ),
                _c("div", {
                  staticClass: "positionAB phoneVideo-close",
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                }),
                _c("video", {
                  staticClass: "phoneVideo-Play positionAB",
                  attrs: {
                    id: "vidPe",
                    src: _vm.videoPlay,
                    controls: "controls",
                    width: "975px",
                    autostart: "false",
                    loop: "false"
                  }
                })
              ])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ab1a4c42", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab1a4c42","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/playVideo/playVideo.vue
// module id = 821
// module chunks = 1 2 7 8 11